<template>
    <div class="form-error error" v-html="displayErrors()"></div>
</template>

<script setup>

import { computed } from 'vue';

let props = defineProps( [ 'error' ] );

let error = computed( () => props?.error ?? [] );


function displayErrors ()
{
    if ( Array.isArray( error.value ) )
    {
        return error.value.join( '<br>' );
    }

    return error.value;
}
</script>

<style scoped>

</style>
